import { useLocation, useNavigate } from "react-router-dom";
import { applicationApi, useGetInterimDashboardQuery } from "pages/application/applicationService";
import { useDispatch, useSelector } from "react-redux";
import {
  getNhDealApplicationId,
  getCurrentUserId,
  setIsInterimDashboard,
  getIsConsentCollected,
  getCurrentUserApplicationId,
  getNhApplicationStatus,
} from "features/authSlice";
import { useEffect } from "react";
import { ApplicationStatusNames } from "utilities/Constant";

const usePerformRouting = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const applicationId = useSelector(getCurrentUserApplicationId);
  const isConsentCollected = useSelector(getIsConsentCollected);
  const id = useSelector(getNhDealApplicationId);
  const nhApplicationStatus = useSelector(getNhApplicationStatus);
  const userId = useSelector(getCurrentUserId);
  useEffect(() => {
    if (!userId) {
      return;
    }
    applicationApi.util.prefetch("getMyLoans", userId, { force: false });
  }, [userId]);
  const { data: hasInterimDashboard, isSuccess, isFetching } = useGetInterimDashboardQuery({ id, userId });

  const dispatch = useDispatch();
  const getRouteForApplicationPath = (nhApplicationId?: string): string => {
    return nhApplicationId ? "/application" : "/path";
  };

  const isNavigateToPreviewPAL = (searchParams: URLSearchParams): boolean => {
    const hasPalInstanceId = searchParams.has("palInstanceId");
    const hasId = searchParams.has("Id");
    return hasPalInstanceId && hasId && Array.from(searchParams.keys()).length > 0;
  };
  const isApplicationCompleted = nhApplicationStatus.toLowerCase() == ApplicationStatusNames.Completed.toLowerCase();
  useEffect(() => {
    if (!isFetching && isSuccess && hasInterimDashboard !== undefined) {
      performRouting();
    }
  }, [isSuccess, hasInterimDashboard, isFetching]);

  const performRouting = () => {
    const searchParams = new URLSearchParams(search);
    if (!isSuccess) {
      return;
    }

    if (isApplicationCompleted) {
      dispatch(setIsInterimDashboard(hasInterimDashboard));
      if (!isNavigateToPreviewPAL(searchParams)) {
        navigate("/dashboard", { replace: true });
        return;
      }
    } else if (!isConsentCollected) {
      navigate("/path", { replace: true });
      return;
    } else if (hasInterimDashboard) {
      dispatch(setIsInterimDashboard(hasInterimDashboard));
      if (!isNavigateToPreviewPAL(searchParams)) {
        navigate("/dashboard", { replace: true });
        return;
      }
    } else {
      navigate(getRouteForApplicationPath(applicationId), { replace: true });
      return;
    }
  };
  return { isSuccess, performRouting };
};

export default usePerformRouting;
